/* Tracking Event Workflow Transition client data model
 *
 *  class WorkflowTransition
 *
 */

import makePropsEnumerable from "../utility/MakePropsEnumerable";

function GetTransitionApiParams(transitionName) {
    var transitionServerParams = null;

    switch (transitionName) {
        case "ReportTrackedAndReported":
            transitionServerParams = {
                EventWasTracked: true,
                AccessPermitted: true
            };
            break;

        case "ReportTrackedAccessDenied":
            transitionServerParams = {
                EventWasTracked: true,
                AccessPermitted: false
            };
            break;

        case "ReportNotTracked":
            transitionServerParams = {
                EventWasTracked: false
            };
            break;
    }

    return transitionServerParams;
}

class WorkflowTransition {
    constructor(
        transitionName,
        transitionUrl,
        transitionFriendlyName,
        preCheckTransitionUrl
    ) {

        if ((angular.isDefined(transitionName)) &&
            (angular.isString(transitionName)))
        {
            this.name = transitionName;
        }
        else {
            throw new TypeError("Missing or invalid transition name value");
        }

        if ((angular.isDefined(transitionUrl)) &&
            (angular.isString(transitionUrl)))
        {
            this.apiUrl = transitionUrl;
        }
        else {
            throw new TypeError("Missing or invalid transition name value");
        }

        this.friendlyName = "";
        if ((angular.isDefined(transitionFriendlyName)) &&
            (angular.isString(transitionFriendlyName)))
        {
            this.friendlyName = transitionFriendlyName;
        }

        //Precompute the transition parameters.
        this.serverApiParams = GetTransitionApiParams(this.name);

        this.preCheckTransitionApiUrl = null;
        if ((angular.isDefined(preCheckTransitionUrl)) &&
            (angular.isString(preCheckTransitionUrl)))
        {
            this.preCheckTransitionApiUrl = preCheckTransitionUrl;
        }
    }

    get displayName() {
        if (this.friendlyName.length > 0) {
            return this.friendlyName;
        }
        else {
            return this.name;
        }
    }

    get isReportRequired() {
        return this.name.match(/^Report/);
    }

    get serverParams() {
        return this.serverApiParams;
    }

    get preCheckAvailable() {
        return (this.preCheckTransitionApiUrl != null);
    }


}

makePropsEnumerable(WorkflowTransition.prototype, [
    "displayName",
    "isReportRequired",
    "serverParams",
    "preCheckAvailable"
]);

export default WorkflowTransition;



//////////////////
// WEBPACK FOOTER
// ./src/models/TrackingEventWorkflowTransition.js
// module id = j2um
// module chunks = 1